// Look and small pieces shared by the CRM panel and the lead sweep.
export const field = "border-white/10 bg-vortex-ink/60 text-slate-100 focus-visible:ring-vortex-cyan";
export const selectBase = "h-10 rounded-md border border-white/10 bg-vortex-ink/60 px-3 text-sm text-slate-100 focus:outline-none focus:ring-2 focus:ring-vortex-cyan";
export const select = `${selectBase} w-full`;
export const label = "font-mono text-[10px] tracking-[0.25em] text-slate-400 uppercase";
export const btnPrimary = "flex items-center justify-center gap-2 rounded-full bg-vortex-cyan px-6 py-3 font-mono text-xs tracking-[0.2em] uppercase text-vortex-ink transition-all duration-300 hover:shadow-[0_0_30px_rgba(92,179,226,0.4)] disabled:opacity-50";
export const btnGhost = "flex items-center justify-center gap-2 rounded-full border border-white/15 px-5 py-2.5 font-mono text-[11px] tracking-[0.2em] uppercase text-slate-300 transition-colors hover:border-vortex-cyan/60 hover:text-vortex-cyan disabled:opacity-50";
export const card = "border border-white/10 bg-vortex-surface/60";

export const POTENTIAL_STYLE = {
  high: "border-emerald-400/60 bg-emerald-400/10 text-emerald-300",
  medium: "border-amber-400/60 bg-amber-400/10 text-amber-300",
  low: "border-slate-500/50 text-slate-400",
};
export const PotentialPill = ({ potential, long = false }) => (potential ? (
  <span title="Vending potential (0-100)" data-testid="crm-potential"
    className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 font-mono text-[10px] tracking-[0.12em] uppercase ${POTENTIAL_STYLE[potential.level]}`}>
    {long ? `Vending potential ${potential.score} · ${potential.level}` : `Potential ${potential.score}`}
  </span>
) : null);

export const Pill = ({ children, className = "" }) => (
  <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 font-mono text-[10px] tracking-[0.12em] uppercase ${className}`}>
    {children}
  </span>
);

// Google Maps URLs are free to open (no API key, no charge). Street View needs coordinates;
// without them the place search link lets you drop into Street View from the map.
export const streetViewUrl = (place) => (place.lat != null && place.lng != null
  ? `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${place.lat},${place.lng}`
  : place.address ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${place.company} ${place.address}`)}` : "");

